/**
 * @flow
 * @relayHash de2211b7b3e41353a29980f8a49b2892
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type TitleIssueTable_project$ref = any;
export type FilterOperator = "AND" | "OR" | "%future added value";
export type TextFilterOperator = "CONTAINS" | "NOT_CONTAINS" | "REGEXP" | "%future added value";
export type TextFilters = {
  operator: FilterOperator,
  values?: ?$ReadOnlyArray<?TextFilter>,
};
export type TextFilter = {
  operator: TextFilterOperator,
  value: string,
};
export type TitleIssueTable_RefetchQueryVariables = {|
  offset?: ?number,
  limit?: ?number,
  typeFilters?: ?$ReadOnlyArray<?string>,
  lenOrder?: ?number,
  title?: ?TextFilters,
  url?: ?TextFilters,
  host: string,
|};
export type TitleIssueTable_RefetchQueryResponse = {|
  +project: ?{|
    +$fragmentRefs: TitleIssueTable_project$ref
  |}
|};
export type TitleIssueTable_RefetchQuery = {|
  variables: TitleIssueTable_RefetchQueryVariables,
  response: TitleIssueTable_RefetchQueryResponse,
|};
*/


/*
query TitleIssueTable_RefetchQuery(
  $offset: Int
  $limit: Int
  $typeFilters: [String]
  $lenOrder: Int
  $title: TextFilters
  $url: TextFilters
  $host: String!
) {
  project(host: $host) {
    ...TitleIssueTable_project_4zOmku
    id
  }
}

fragment TitleIssueTable_project_4zOmku on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        countTypesTitleIssues(title: $title, url: $url) {
          type
          severity
          count
        }
        titleIssues(offset: $offset, limit: $limit, typeFilters: $typeFilters, url: $url, lenOrder: $lenOrder, title: $title) {
          count
          edges {
            node {
              id
              ...TitleIssueRow_issue
            }
          }
        }
        id
      }
    }
  }
}

fragment TitleIssueRow_issue on TitleIssue {
  id
  severity
  title
  title_len_chr
  title_len_px
  type
  urls
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "limit",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "typeFilters",
    "type": "[String]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "lenOrder",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "title",
    "type": "TextFilters",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "url",
    "type": "TextFilters",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "Variable",
  "name": "title",
  "variableName": "title",
  "type": "TextFilters"
},
v3 = {
  "kind": "Variable",
  "name": "url",
  "variableName": "url",
  "type": "TextFilters"
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "severity",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "TitleIssueTable_RefetchQuery",
  "id": null,
  "text": "query TitleIssueTable_RefetchQuery(\n  $offset: Int\n  $limit: Int\n  $typeFilters: [String]\n  $lenOrder: Int\n  $title: TextFilters\n  $url: TextFilters\n  $host: String!\n) {\n  project(host: $host) {\n    ...TitleIssueTable_project_4zOmku\n    id\n  }\n}\n\nfragment TitleIssueTable_project_4zOmku on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        countTypesTitleIssues(title: $title, url: $url) {\n          type\n          severity\n          count\n        }\n        titleIssues(offset: $offset, limit: $limit, typeFilters: $typeFilters, url: $url, lenOrder: $lenOrder, title: $title) {\n          count\n          edges {\n            node {\n              id\n              ...TitleIssueRow_issue\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment TitleIssueRow_issue on TitleIssue {\n  id\n  severity\n  title\n  title_len_chr\n  title_len_px\n  type\n  urls\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "TitleIssueTable_RefetchQuery",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "TitleIssueTable_project",
            "args": [
              {
                "kind": "Variable",
                "name": "lenOrder",
                "variableName": "lenOrder",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "limit",
                "variableName": "limit",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "offset",
                "variableName": "offset",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "title",
                "variableName": "title",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "typeFilters",
                "variableName": "typeFilters",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "url",
                "variableName": "url",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "TitleIssueTable_RefetchQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "offset",
                "value": 0,
                "type": "Int"
              }
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "countTypesTitleIssues",
                        "storageKey": null,
                        "args": [
                          v2,
                          v3
                        ],
                        "concreteType": "CountType",
                        "plural": true,
                        "selections": [
                          v4,
                          v5,
                          v6
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "titleIssues",
                        "storageKey": null,
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "lenOrder",
                            "variableName": "lenOrder",
                            "type": "Int"
                          },
                          {
                            "kind": "Variable",
                            "name": "limit",
                            "variableName": "limit",
                            "type": "Int"
                          },
                          {
                            "kind": "Variable",
                            "name": "offset",
                            "variableName": "offset",
                            "type": "Int"
                          },
                          v2,
                          {
                            "kind": "Variable",
                            "name": "typeFilters",
                            "variableName": "typeFilters",
                            "type": "[String]"
                          },
                          v3
                        ],
                        "concreteType": "TitleIssuesConnection",
                        "plural": false,
                        "selections": [
                          v6,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "TitleIssuesEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "TitleIssue",
                                "plural": false,
                                "selections": [
                                  v7,
                                  v5,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "title",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "title_len_chr",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "title_len_px",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  v4,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "urls",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v7
                    ]
                  }
                ]
              }
            ]
          },
          v7
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b1ae46502f9b589b707f85c0a314ca5a';
module.exports = node;
